import chartUtils from '../../../utils/chart-utils';

var buildBoxPlotTooltip = function buildBoxPlotTooltip(seriesConfig, data) {
    var defaultTipText = '<span>Min' + ':</span><span> ' + chartUtils.format(data.options.low, seriesConfig.ValueFormat, seriesConfig.CurrencySymbol, null, seriesConfig.BaseFormat) + '</span>';

    defaultTipText = defaultTipText + '<br/><span>Lower Percentile' + ':</span><span> ' + chartUtils.format(data.options.q1, seriesConfig.ValueFormat, seriesConfig.CurrencySymbol, null, seriesConfig.BaseFormat) + '</span>';

    defaultTipText = defaultTipText + '<br/><span>Median' + ':</span><span> ' + chartUtils.format(data.options.median, seriesConfig.ValueFormat, seriesConfig.CurrencySymbol, null, seriesConfig.BaseFormat) + '</span>';

    defaultTipText = defaultTipText + '<br/><span>Upper Percentile' + ':</span><span> ' + chartUtils.format(data.options.q3, seriesConfig.ValueFormat, seriesConfig.CurrencySymbol, null, seriesConfig.BaseFormat) + '</span>';

    defaultTipText = defaultTipText + '<br/><span>Max' + ':</span><span> ' + chartUtils.format(data.options.high, seriesConfig.ValueFormat, seriesConfig.CurrencySymbol, null, seriesConfig.BaseFormat) + '</span>';

    return defaultTipText;
};

export default buildBoxPlotTooltip;